module.exports = __webpack_public_path__ + "static/constructionSign.0aa31e58.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/constructionSign.png
// module id = 462
// module chunks = 35783957827783